import { useBulkDelete } from '@/shared/lib';
import { userApi, useUserStore, type User } from '@/entities/User';
import { useUserManagement } from './useUserManagement';

const SELF_SELECTED_TOAST_MESSAGE =
  'Ops: dentre os usuários selecionados você selecionou a si mesmo!';

export function useUserDelete(
  selectedCount: () => number,
  selectedUsersArray: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void,
  onModalClose?: () => void
) {
  const { getMultipleDeleteDescription } = useUserManagement();
  const userStore = useUserStore();

  return useBulkDelete<User & { id: number }>({
    entityName: {
      singular: 'usuário',
      plural: 'usuários',
    },
    bulkDeleteApi: userApi.bulkDelete.bind(userApi),
    getDeleteDescription: getMultipleDeleteDescription,
    validateSelection: (ids) => {
      const currentId = userStore.id;
      if (currentId != null && ids.includes(currentId)) {
        return { allowed: false, message: SELF_SELECTED_TOAST_MESSAGE };
      }
      return { allowed: true };
    },
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds: selectedUsersArray,
    onModalClose,
  });
}
